// @ts-nocheck
import * as Types from '../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { NamedFragmentDoc } from '../../fragments/commonFragments.generated';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type SubmitChangesForApprovalStep_ChangeBreakdownTableQueryVariables = Types.Exact<{
  changeEventIds: Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input'];
}>;


export type SubmitChangesForApprovalStep_ChangeBreakdownTableQuery = { __typename?: 'Query', changeEvents: Array<{ __typename?: 'ChangeEvent', id: string, originalTotalCostInCents: number, proposedTotalCostInCents: number, totalCostInCents: number, project:
      | { __typename?: 'StandaloneProject', id: string, name: string, budgetFinancials: { __typename?: 'ProjectBudgetFinancials', originalBudgetInCents: number } }
      | { __typename?: 'Region', id: string, name: string, budgetFinancials: { __typename?: 'ProjectBudgetFinancials', originalBudgetInCents: number } }
      | { __typename?: 'Market', id: string, name: string, budgetFinancials: { __typename?: 'ProjectBudgetFinancials', originalBudgetInCents: number } }
      | { __typename?: 'Community', id: string, name: string, budgetFinancials: { __typename?: 'ProjectBudgetFinancials', originalBudgetInCents: number } }
      | { __typename?: 'Subdivision', id: string, name: string, budgetFinancials: { __typename?: 'ProjectBudgetFinancials', originalBudgetInCents: number } }
      | { __typename?: 'Lot', id: string, name: string, budgetFinancials: { __typename?: 'ProjectBudgetFinancials', originalBudgetInCents: number } }
      | { __typename?: 'Structure', id: string, name: string, budgetFinancials: { __typename?: 'ProjectBudgetFinancials', originalBudgetInCents: number } }
      | { __typename?: 'Unit', id: string, name: string, budgetFinancials: { __typename?: 'ProjectBudgetFinancials', originalBudgetInCents: number } }
     }> };

export type ToggleCommitmentReleaseMutationVariables = Types.Exact<{
  input: Types.SaveCommitmentInput;
}>;


export type ToggleCommitmentReleaseMutation = { __typename?: 'Mutation', saveCommitment: { __typename?: 'SaveCommitmentResult', commitment: { __typename?: 'Commitment', id: string, releaseWhenReady?: boolean | null | undefined } } };

export type OpenManyChangeEventApprovalsMutationVariables = Types.Exact<{
  changeEventInputs: Array<Types.SaveChangeEventsInput> | Types.SaveChangeEventsInput;
  approvalInputs: Array<Types.SaveApprovalInput> | Types.SaveApprovalInput;
}>;


export type OpenManyChangeEventApprovalsMutation = { __typename?: 'Mutation', saveChangeEvents: { __typename?: 'SaveChangeEventsResult', changeEvents: Array<{ __typename?: 'ChangeEvent', id: string, status: Types.ChangeEventStatus, internalNote?: string | null | undefined, reason: { __typename?: 'ChangeEventReason', id: string, code: string, name: string } }> }, saveApprovals: { __typename?: 'SaveApprovalsResult', approvals: Array<{ __typename?: 'Approval', id: string, dueOn?: Types.Scalars['Date']['input'] | null | undefined, status: { __typename?: 'ApprovalStatusDetail', code: Types.ApprovalStatus, name: string } }> } };

export type SubmitChangeEventApprovalStepView_ChangeEventFragment = { __typename?: 'ChangeEvent', id: string, originalTotalCostInCents: number, proposedTotalCostInCents: number, totalCostInCents: number, project:
    | { __typename?: 'StandaloneProject', id: string, name: string, budgetFinancials: { __typename?: 'ProjectBudgetFinancials', originalBudgetInCents: number } }
    | { __typename?: 'Region', id: string, name: string, budgetFinancials: { __typename?: 'ProjectBudgetFinancials', originalBudgetInCents: number } }
    | { __typename?: 'Market', id: string, name: string, budgetFinancials: { __typename?: 'ProjectBudgetFinancials', originalBudgetInCents: number } }
    | { __typename?: 'Community', id: string, name: string, budgetFinancials: { __typename?: 'ProjectBudgetFinancials', originalBudgetInCents: number } }
    | { __typename?: 'Subdivision', id: string, name: string, budgetFinancials: { __typename?: 'ProjectBudgetFinancials', originalBudgetInCents: number } }
    | { __typename?: 'Lot', id: string, name: string, budgetFinancials: { __typename?: 'ProjectBudgetFinancials', originalBudgetInCents: number } }
    | { __typename?: 'Structure', id: string, name: string, budgetFinancials: { __typename?: 'ProjectBudgetFinancials', originalBudgetInCents: number } }
    | { __typename?: 'Unit', id: string, name: string, budgetFinancials: { __typename?: 'ProjectBudgetFinancials', originalBudgetInCents: number } }
   };

export type CreateChangeEventApproval_ImpactedPosTableQueryVariables = Types.Exact<{
  changeEventIds: Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input'];
}>;


export type CreateChangeEventApproval_ImpactedPosTableQuery = { __typename?: 'Query', changeEvents: Array<{ __typename?: 'ChangeEvent', id: string, commitments: Array<
      | { __typename?: 'Commitment', id: string, costChangeInCents: number, releaseWhenReady?: boolean | null | undefined, accountingNumber: number, executionDate?: Types.Scalars['Date']['input'] | null | undefined, status: Types.CommitmentStatus, committedInCents: number, voidsCommitments: Array<{ __typename?: 'Commitment', id: string, costChangeInCents: number, releaseWhenReady?: boolean | null | undefined, accountingNumber: number, executionDate?: Types.Scalars['Date']['input'] | null | undefined, status: Types.CommitmentStatus, committedInCents: number, bidContractRevision?: { __typename?: 'BidContractRevision', id: string, version: string } | null | undefined, project:
            | { __typename?: 'StandaloneProject', id: string, name: string }
            | { __typename?: 'Region', id: string, name: string }
            | { __typename?: 'Market', id: string, name: string }
            | { __typename?: 'Community', id: string, name: string }
            | { __typename?: 'Subdivision', id: string, name: string }
            | { __typename?: 'Lot', id: string, name: string }
            | { __typename?: 'Structure', id: string, name: string }
            | { __typename?: 'Unit', id: string, name: string }
          , tradePartner?: { __typename?: 'TradePartner', id: string, name: string } | null | undefined, items: Array<{ __typename?: 'Item', id: string, displayName: string, fullCode: string }>, blueprintUrl: { __typename?: 'Url', path: string } }>, bidContractRevision?: { __typename?: 'BidContractRevision', id: string, version: string } | null | undefined, project:
          | { __typename?: 'StandaloneProject', id: string, name: string }
          | { __typename?: 'Region', id: string, name: string }
          | { __typename?: 'Market', id: string, name: string }
          | { __typename?: 'Community', id: string, name: string }
          | { __typename?: 'Subdivision', id: string, name: string }
          | { __typename?: 'Lot', id: string, name: string }
          | { __typename?: 'Structure', id: string, name: string }
          | { __typename?: 'Unit', id: string, name: string }
        , tradePartner?: { __typename?: 'TradePartner', id: string, name: string } | null | undefined, items: Array<{ __typename?: 'Item', id: string, displayName: string, fullCode: string }>, blueprintUrl: { __typename?: 'Url', path: string } }
      | { __typename?: 'CommitmentChangeOrder', id: string, costChangeInCents: number, accountingNumber: number, executionDate?: Types.Scalars['Date']['input'] | null | undefined, status: Types.CommitmentStatus, committedInCents: number, tradePartner?: { __typename?: 'TradePartner', id: string, name: string } | null | undefined, items: Array<{ __typename?: 'Item', id: string, displayName: string, fullCode: string }>, blueprintUrl: { __typename?: 'Url', path: string } }
    > }> };

export type SubmitChangeEventApprovalStepView_CommitmentLikes_Commitment_Fragment = { __typename?: 'Commitment', id: string, costChangeInCents: number, releaseWhenReady?: boolean | null | undefined, accountingNumber: number, executionDate?: Types.Scalars['Date']['input'] | null | undefined, status: Types.CommitmentStatus, committedInCents: number, bidContractRevision?: { __typename?: 'BidContractRevision', id: string, version: string } | null | undefined, project:
    | { __typename?: 'StandaloneProject', id: string, name: string }
    | { __typename?: 'Region', id: string, name: string }
    | { __typename?: 'Market', id: string, name: string }
    | { __typename?: 'Community', id: string, name: string }
    | { __typename?: 'Subdivision', id: string, name: string }
    | { __typename?: 'Lot', id: string, name: string }
    | { __typename?: 'Structure', id: string, name: string }
    | { __typename?: 'Unit', id: string, name: string }
  , tradePartner?: { __typename?: 'TradePartner', id: string, name: string } | null | undefined, items: Array<{ __typename?: 'Item', id: string, displayName: string, fullCode: string }>, blueprintUrl: { __typename?: 'Url', path: string } };

export type SubmitChangeEventApprovalStepView_CommitmentLikes_CommitmentChangeOrder_Fragment = { __typename?: 'CommitmentChangeOrder', id: string, costChangeInCents: number, accountingNumber: number, executionDate?: Types.Scalars['Date']['input'] | null | undefined, status: Types.CommitmentStatus, committedInCents: number, tradePartner?: { __typename?: 'TradePartner', id: string, name: string } | null | undefined, items: Array<{ __typename?: 'Item', id: string, displayName: string, fullCode: string }>, blueprintUrl: { __typename?: 'Url', path: string } };

export type SubmitChangeEventApprovalStepView_CommitmentLikesFragment =
  | SubmitChangeEventApprovalStepView_CommitmentLikes_Commitment_Fragment
  | SubmitChangeEventApprovalStepView_CommitmentLikes_CommitmentChangeOrder_Fragment
;

export const SubmitChangeEventApprovalStepView_ChangeEventFragmentDoc = gql`
    fragment SubmitChangeEventApprovalStepView_ChangeEvent on ChangeEvent {
  id
  project {
    id
    name
    budgetFinancials {
      originalBudgetInCents
    }
  }
  originalTotalCostInCents
  proposedTotalCostInCents
  totalCostInCents
}
    `;
export const SubmitChangeEventApprovalStepView_CommitmentLikesFragmentDoc = gql`
    fragment SubmitChangeEventApprovalStepView_CommitmentLikes on CommitmentLike {
  id
  accountingNumber
  tradePartner {
    ...Named
  }
  items {
    id
    displayName
    fullCode
  }
  executionDate
  status
  blueprintUrl {
    path
  }
  committedInCents
  ... on Commitment {
    id
    costChangeInCents
    bidContractRevision {
      id
      version
    }
    project {
      ...Named
    }
    releaseWhenReady
  }
  ... on CommitmentChangeOrder {
    id
    costChangeInCents
  }
}
    ${NamedFragmentDoc}`;
export const SubmitChangesForApprovalStep_ChangeBreakdownTableDocument = gql`
    query SubmitChangesForApprovalStep_ChangeBreakdownTable($changeEventIds: [ID!]!) {
  changeEvents(filter: {id: $changeEventIds}) {
    ...SubmitChangeEventApprovalStepView_ChangeEvent
  }
}
    ${SubmitChangeEventApprovalStepView_ChangeEventFragmentDoc}`;

/**
 * __useSubmitChangesForApprovalStep_ChangeBreakdownTableQuery__
 *
 * To run a query within a React component, call `useSubmitChangesForApprovalStep_ChangeBreakdownTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubmitChangesForApprovalStep_ChangeBreakdownTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubmitChangesForApprovalStep_ChangeBreakdownTableQuery({
 *   variables: {
 *      changeEventIds: // value for 'changeEventIds'
 *   },
 * });
 */
export function useSubmitChangesForApprovalStep_ChangeBreakdownTableQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SubmitChangesForApprovalStep_ChangeBreakdownTableQuery, SubmitChangesForApprovalStep_ChangeBreakdownTableQueryVariables> & ({ variables: SubmitChangesForApprovalStep_ChangeBreakdownTableQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SubmitChangesForApprovalStep_ChangeBreakdownTableQuery, SubmitChangesForApprovalStep_ChangeBreakdownTableQueryVariables>(SubmitChangesForApprovalStep_ChangeBreakdownTableDocument, options);
      }
export function useSubmitChangesForApprovalStep_ChangeBreakdownTableLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SubmitChangesForApprovalStep_ChangeBreakdownTableQuery, SubmitChangesForApprovalStep_ChangeBreakdownTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SubmitChangesForApprovalStep_ChangeBreakdownTableQuery, SubmitChangesForApprovalStep_ChangeBreakdownTableQueryVariables>(SubmitChangesForApprovalStep_ChangeBreakdownTableDocument, options);
        }
// @ts-ignore
export function useSubmitChangesForApprovalStep_ChangeBreakdownTableSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SubmitChangesForApprovalStep_ChangeBreakdownTableQuery, SubmitChangesForApprovalStep_ChangeBreakdownTableQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SubmitChangesForApprovalStep_ChangeBreakdownTableQuery, SubmitChangesForApprovalStep_ChangeBreakdownTableQueryVariables>;
export function useSubmitChangesForApprovalStep_ChangeBreakdownTableSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SubmitChangesForApprovalStep_ChangeBreakdownTableQuery, SubmitChangesForApprovalStep_ChangeBreakdownTableQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SubmitChangesForApprovalStep_ChangeBreakdownTableQuery | undefined, SubmitChangesForApprovalStep_ChangeBreakdownTableQueryVariables>;
export function useSubmitChangesForApprovalStep_ChangeBreakdownTableSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SubmitChangesForApprovalStep_ChangeBreakdownTableQuery, SubmitChangesForApprovalStep_ChangeBreakdownTableQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SubmitChangesForApprovalStep_ChangeBreakdownTableQuery, SubmitChangesForApprovalStep_ChangeBreakdownTableQueryVariables>(SubmitChangesForApprovalStep_ChangeBreakdownTableDocument, options);
        }
export type SubmitChangesForApprovalStep_ChangeBreakdownTableQueryHookResult = ReturnType<typeof useSubmitChangesForApprovalStep_ChangeBreakdownTableQuery>;
export type SubmitChangesForApprovalStep_ChangeBreakdownTableLazyQueryHookResult = ReturnType<typeof useSubmitChangesForApprovalStep_ChangeBreakdownTableLazyQuery>;
export type SubmitChangesForApprovalStep_ChangeBreakdownTableSuspenseQueryHookResult = ReturnType<typeof useSubmitChangesForApprovalStep_ChangeBreakdownTableSuspenseQuery>;
export type SubmitChangesForApprovalStep_ChangeBreakdownTableQueryResult = ApolloReactCommon.QueryResult<SubmitChangesForApprovalStep_ChangeBreakdownTableQuery, SubmitChangesForApprovalStep_ChangeBreakdownTableQueryVariables>;
export const ToggleCommitmentReleaseDocument = gql`
    mutation ToggleCommitmentRelease($input: SaveCommitmentInput!) {
  saveCommitment(input: $input) {
    commitment {
      id
      releaseWhenReady
    }
  }
}
    `;

/**
 * __useToggleCommitmentReleaseMutation__
 *
 * To run a mutation, you first call `useToggleCommitmentReleaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleCommitmentReleaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleCommitmentReleaseMutation, { data, loading, error }] = useToggleCommitmentReleaseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useToggleCommitmentReleaseMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ToggleCommitmentReleaseMutation, ToggleCommitmentReleaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ToggleCommitmentReleaseMutation, ToggleCommitmentReleaseMutationVariables>(ToggleCommitmentReleaseDocument, options);
      }
export type ToggleCommitmentReleaseMutationHookResult = ReturnType<typeof useToggleCommitmentReleaseMutation>;
export type ToggleCommitmentReleaseMutationResult = ApolloReactCommon.MutationResult<ToggleCommitmentReleaseMutation>;
export const OpenManyChangeEventApprovalsDocument = gql`
    mutation OpenManyChangeEventApprovals($changeEventInputs: [SaveChangeEventsInput!]!, $approvalInputs: [SaveApprovalInput!]!) {
  saveChangeEvents(input: $changeEventInputs) {
    changeEvents {
      id
      status
      internalNote
      reason {
        id
        code
        name
      }
    }
  }
  saveApprovals(input: $approvalInputs) {
    approvals {
      id
      status {
        code
        name
      }
      dueOn
    }
  }
}
    `;

/**
 * __useOpenManyChangeEventApprovalsMutation__
 *
 * To run a mutation, you first call `useOpenManyChangeEventApprovalsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOpenManyChangeEventApprovalsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [openManyChangeEventApprovalsMutation, { data, loading, error }] = useOpenManyChangeEventApprovalsMutation({
 *   variables: {
 *      changeEventInputs: // value for 'changeEventInputs'
 *      approvalInputs: // value for 'approvalInputs'
 *   },
 * });
 */
export function useOpenManyChangeEventApprovalsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<OpenManyChangeEventApprovalsMutation, OpenManyChangeEventApprovalsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<OpenManyChangeEventApprovalsMutation, OpenManyChangeEventApprovalsMutationVariables>(OpenManyChangeEventApprovalsDocument, options);
      }
export type OpenManyChangeEventApprovalsMutationHookResult = ReturnType<typeof useOpenManyChangeEventApprovalsMutation>;
export type OpenManyChangeEventApprovalsMutationResult = ApolloReactCommon.MutationResult<OpenManyChangeEventApprovalsMutation>;
export const CreateChangeEventApproval_ImpactedPosTableDocument = gql`
    query CreateChangeEventApproval_ImpactedPosTable($changeEventIds: [ID!]!) {
  changeEvents(filter: {id: $changeEventIds}) {
    id
    commitments {
      ...SubmitChangeEventApprovalStepView_CommitmentLikes
      ... on Commitment {
        id
        voidsCommitments {
          ...SubmitChangeEventApprovalStepView_CommitmentLikes
        }
      }
    }
  }
}
    ${SubmitChangeEventApprovalStepView_CommitmentLikesFragmentDoc}`;

/**
 * __useCreateChangeEventApproval_ImpactedPosTableQuery__
 *
 * To run a query within a React component, call `useCreateChangeEventApproval_ImpactedPosTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreateChangeEventApproval_ImpactedPosTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreateChangeEventApproval_ImpactedPosTableQuery({
 *   variables: {
 *      changeEventIds: // value for 'changeEventIds'
 *   },
 * });
 */
export function useCreateChangeEventApproval_ImpactedPosTableQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CreateChangeEventApproval_ImpactedPosTableQuery, CreateChangeEventApproval_ImpactedPosTableQueryVariables> & ({ variables: CreateChangeEventApproval_ImpactedPosTableQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CreateChangeEventApproval_ImpactedPosTableQuery, CreateChangeEventApproval_ImpactedPosTableQueryVariables>(CreateChangeEventApproval_ImpactedPosTableDocument, options);
      }
export function useCreateChangeEventApproval_ImpactedPosTableLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CreateChangeEventApproval_ImpactedPosTableQuery, CreateChangeEventApproval_ImpactedPosTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CreateChangeEventApproval_ImpactedPosTableQuery, CreateChangeEventApproval_ImpactedPosTableQueryVariables>(CreateChangeEventApproval_ImpactedPosTableDocument, options);
        }
// @ts-ignore
export function useCreateChangeEventApproval_ImpactedPosTableSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<CreateChangeEventApproval_ImpactedPosTableQuery, CreateChangeEventApproval_ImpactedPosTableQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CreateChangeEventApproval_ImpactedPosTableQuery, CreateChangeEventApproval_ImpactedPosTableQueryVariables>;
export function useCreateChangeEventApproval_ImpactedPosTableSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CreateChangeEventApproval_ImpactedPosTableQuery, CreateChangeEventApproval_ImpactedPosTableQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CreateChangeEventApproval_ImpactedPosTableQuery | undefined, CreateChangeEventApproval_ImpactedPosTableQueryVariables>;
export function useCreateChangeEventApproval_ImpactedPosTableSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CreateChangeEventApproval_ImpactedPosTableQuery, CreateChangeEventApproval_ImpactedPosTableQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CreateChangeEventApproval_ImpactedPosTableQuery, CreateChangeEventApproval_ImpactedPosTableQueryVariables>(CreateChangeEventApproval_ImpactedPosTableDocument, options);
        }
export type CreateChangeEventApproval_ImpactedPosTableQueryHookResult = ReturnType<typeof useCreateChangeEventApproval_ImpactedPosTableQuery>;
export type CreateChangeEventApproval_ImpactedPosTableLazyQueryHookResult = ReturnType<typeof useCreateChangeEventApproval_ImpactedPosTableLazyQuery>;
export type CreateChangeEventApproval_ImpactedPosTableSuspenseQueryHookResult = ReturnType<typeof useCreateChangeEventApproval_ImpactedPosTableSuspenseQuery>;
export type CreateChangeEventApproval_ImpactedPosTableQueryResult = ApolloReactCommon.QueryResult<CreateChangeEventApproval_ImpactedPosTableQuery, CreateChangeEventApproval_ImpactedPosTableQueryVariables>;